import { render, staticRenderFns } from "./VersionKV.vue?vue&type=template&id=41412164&scoped=true"
import script from "./VersionKV.vue?vue&type=script&lang=js"
export * from "./VersionKV.vue?vue&type=script&lang=js"
import style0 from "./VersionKV.vue?vue&type=style&index=0&id=41412164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41412164",
  null
  
)

export default component.exports